var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconNote = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66797 0.333328C1.5634 0.333328 0.667969 1.22876 0.667969 2.33333V11.6667C0.667969 12.7712 1.5634 13.6667 2.66797 13.6667H9.33463C10.4392 13.6667 11.3346 12.7712 11.3346 11.6667V2.33333C11.3346 1.22876 10.4392 0.333328 9.33463 0.333328H2.66797ZM8.66797 9H3.33464V10.3333H8.66797V9ZM3.33464 6.33333H8.66797V7.66666H3.33464V6.33333ZM8.66797 3.66666H3.33464V4.99999H8.66797V3.66666Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconNote);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-note.47d68fb7b760e823145afbc96816c38e.svg";